import { Button } from "@/components/ui/button";
import { CirclePlus } from "lucide-react";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { generatePath, useNavigate } from "react-router-dom";
import { PATH_PROJECT_ROLE_NEW } from "@/constants";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { useCheckIsProjectLocked } from "../../hooks/useCheckIsProjectLocked";

interface ProjectRoleAddButtonProps {
  projectId: string;
}
const ProjectRoleAddButtonComponent = ({
  projectId,
}: ProjectRoleAddButtonProps) => {
  const { can_create } = useModulePermissions();
  const isProjectLocked = useCheckIsProjectLocked();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onAddRole = useCallback(() => {
    navigate(
      generatePath(PATH_PROJECT_ROLE_NEW, {
        projectId,
      }),
    );
  }, [navigate, projectId]);

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onAddRole}
      key="edit"
      disabled={!can_create || isProjectLocked}
    >
      <CirclePlus className="w-5 h-5 mr-1" />
      {t("projectRoles.buttons.add")}
    </Button>
  );
};

export const ProjectRoleAddButton = memo(ProjectRoleAddButtonComponent);
